import React, {useState, useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {FaArrowLeft, FaCheck} from 'react-icons/fa';
import Post from './components/Post';
import Get from './components/Get';

const option = {
  title: 'Loading',
  message: 'Please Wait..',
  isCancelable: true,
};

export default function PostFree() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state?.data || {};

  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [numbers, setNumbers] = useState([]);
  const [fk_game_timer_id, setFkGameTimerId] = useState(params.id || null);
  const [bidding_type] = useState('open');
  const [gameName, setGameName] = useState(params.name?.name || 'Jodi');

  useEffect(() => {
    fetchWallet();
    generateNumbers();
  }, []);

  const fetchWallet = () => {
    Get.Wallet().then(res => {
      if (res.wallet) {
        setWalletBalance(res.wallet.balance);
      }
    });
  };

  const generateNumbers = () => {
    const nums = Array.from({length: 100}, (_, i) => i + 1).map(num => ({
      number: num,
      amount: '',
    }));
    setNumbers(nums);
  };

  const enter = (value, key) => {
    const newData = [...data];
    newData[key] = {amount: value, number: key, type: 'j'};
    setData(newData);
    calculateTotal(newData);
  };

  const calculateTotal = dataArr => {
    let sum = 0;
    dataArr.forEach(item => {
      if (item && item.amount) {
        sum += parseFloat(item.amount);
      }
    });
    setTotal(sum);
  };

  const submit = () => {
    // Mimicking DialogProgress.show(option);
    console.log('Submitting...', option);

    const filteredData = data.filter(d => d && d.amount);

    Post.Bidding({
      data: filteredData,
      fk_game_timer_id,
      bidding_type,
    }).then(res => {
      console.log(res);
      if (res.success) {
        setData([]);
        setNumbers([]);
        setTotal(0);
        alert('Successfully submitted!');
        fetchWallet();
      } else {
        alert(res.errorMsg || 'An error occurred.');
      }
    });
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerContainer}>
        <button style={styles.backButton} onClick={() => navigate(-1)}>
          <FaArrowLeft />
        </button>
        <span style={styles.headerTitle}>{gameName}</span>
        <div style={styles.headerPlaceholder}></div>
      </div>

      <div style={styles.scrollContainer}>
        <div style={styles.gameCard}>
          <div style={styles.numbersGrid}>
            {numbers.map(numObj => (
              <div key={numObj.number} style={styles.colNumber}>
                <div style={styles.numberHeader}>
                  <span style={styles.numberText}>
                    {numObj.number < 10
                      ? '0' + numObj.number
                      : numObj.number === 100
                      ? '00'
                      : numObj.number}
                  </span>
                </div>
                <input
                  type="number"
                  placeholder="₹"
                  value={numObj.amount}
                  onChange={e => {
                    const val = e.target.value;
                    setNumbers(prev =>
                      prev.map(n =>
                        n.number === numObj.number ? {...n, amount: val} : n,
                      ),
                    );
                    enter(val, numObj.number);
                  }}
                  style={styles.TextField}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={styles.bottomBar}>
        <div style={styles.totalContainer}>
          <div style={styles.totalCard}>
            <span style={styles.totalAmount}>₹{total}</span>
            <h6 style={styles.totalLabel}>Total Amount</h6>
          </div>
        </div>

        <button style={styles.submitButton} onClick={submit}>
          <FaCheck style={{marginRight: 8}} />
          <span style={styles.submitText}>Submit Bet</span>
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#F8FAFB',
    minHeight: '100vh',
  },
  headerContainer: {
    backgroundColor: '#1057D7',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#fff',
  },
  backButton: {
    width: '40px',
    height: '40px',
    borderRadius: '20px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    cursor: 'pointer',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
  },
  headerPlaceholder: {
    width: '40px',
  },
  scrollContainer: {
    padding: '5px',
  },
  gameCard: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '10px',
  },
  numbersGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
  },
  colNumber: {
    width: '60px',
    textAlign: 'center',
  },
  numberHeader: {
    backgroundColor: '#1057D7',
    padding: '5px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  numberText: {
    color: '#fff',
    fontSize: '12px',
    fontWeight: '600',
  },
  TextField: {
    width: '90%',
    height: '30px',
    border: '1.5px solid #10C2AA',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '600',
    color: '#EDA01E',
    backgroundColor: '#F9FAFB',
  },
  bottomBar: {
    backgroundColor: '#fff',
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: '1px solid #E5E7EB',
  },
  totalContainer: {
    flex: 1,
  },
  totalCard: {
    backgroundColor: '#F3DE11',
    borderRadius: '12px',
    padding: '8px',
    textAlign: 'center',
    border: '1px solid #EDA01E',
  },
  totalAmount: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#1057D7',
  },
  totalLabel: {
    fontSize: '13px',
    color: '#6B7280',
    fontWeight: '500',
    margin: 0,
  },
  submitButton: {
    backgroundColor: '#21CB84',
    padding: '16px 20px',
    borderRadius: '12px',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 10,
  },
  submitText: {
    fontSize: '16px',
    fontWeight: '600',
  },
};
